import { render } from "./HolidaysView.vue?vue&type=template&id=7f457ee4&scoped=true"
import script from "./HolidaysView.vue?vue&type=script&lang=js"
export * from "./HolidaysView.vue?vue&type=script&lang=js"

import "./HolidaysView.vue?vue&type=style&index=0&id=7f457ee4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f457ee4"]])

export default __exports__